if (!customElements.get('cart-upsell')) {
  class CartUpsell extends HTMLElement {
    constructor() {
      super();
      this.productJson = JSON.parse(this.dataset.productJson) || null;
      this.variantSelect = this.querySelector('select');
      this.isFreeGift = this.dataset.freeGift || null;
    }
  
    connectedCallback() {
      this.setDefaultSize();
      this.variantSelect.addEventListener('change', (e) => {
        this.querySelector('[data-product-price]').innerText = this.isFreeGift ? 'FREE' : this.productJson.variants[e.target.selectedIndex].price;
        
        if (!this.productJson.variants[e.target.selectedIndex].compare_at_price) return
        this.setCompareAtPrice(this.productJson.variants[e.target.selectedIndex].compare_at_price, this.productJson.variants[e.target.selectedIndex].show_compare_price);
      });
    }

    setDefaultSize() {
      const cartSizes = JSON.parse(localStorage.getItem('cartSizes'));
      let variantIdentifier = cartSizes[this.productJson.product_type];
      if (!cartSizes.hasOwnProperty(this.productJson.product_type)) {
        variantIdentifier = this.productJson.first_item_size;
      }

      for (let i = 0; i < this.variantSelect.options.length; i++) {
        if (this.variantSelect.options[i].disabled) break
        if (this.variantSelect.options[i].innerText === variantIdentifier || this.variantSelect.options[i].innerText.includes(`${variantIdentifier} /`)) {
          const currentVariantJson = this.productJson.variants.filter((variant) => variant.id === this.variantSelect.options[i].value);
          this.variantSelect.options[i].selected = true;
          this.querySelector('[data-product-price]').innerText = this.isFreeGift ? 'FREE' : currentVariantJson[0].price;

          if (!currentVariantJson[0].compare_at_price) return
          this.setCompareAtPrice(currentVariantJson[0].compare_at_price, currentVariantJson[0].show_compare_price);
          break
        }
      }
    }

    setCompareAtPrice(compareAtPrice, showComparePrice) {
      this.querySelector('[data-compare-price]').innerText = compareAtPrice;
      if (showComparePrice === "true") {
        this.querySelector('[data-compare-price]').classList.remove('hidden');
      } else {
        this.querySelector('[data-compare-price]').classList.add('hidden');
      }
    }
  }
  customElements.define('cart-upsell', CartUpsell);
}